import Link from 'next/link';

import clsx from 'clsx';

// Utils
import useNetworkOauthUrls from '@/utils/hooks/signup/useNetworkOauthUrls';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

type ReAuthCTAProps = {
    className?: string;
    label: string;
    socialProfile: SocialProfileType;
};

export function ReAuthCTA({ className, label, socialProfile }: ReAuthCTAProps) {
    const { getOauthUrl } = useNetworkOauthUrls();

    const url = getOauthUrl({
        network: socialProfile.social_network_type,
        query: socialProfile?.auth_status?.params
    });

    return (
        <Link href={url} className={clsx('cursor-pointer rounded p-2', className)}>
            {label}
        </Link>
    );
}
